export default __webpack_public_path__ + "static/media/livestream.d24df1d1.png";